import Vue from 'vue'
import AppImage from '@teamnovu/vue-cloudinary-image-statamic'

Vue.use(AppImage)
